export const featureFlags = {
    budget: false,

    // Módulo de Atendimentos (chamado TAS)
    tasOccurrenceLogsTab: true,
    tasOccurrenceVehicleContainer: true,
    tasOccurrenceVinculateOccurrence: true,
}
